<div
  #trigger
  class="trigger">
  <ng-content
    select="[trigger]"
    [selected]="true" />
</div>

<nav
  evcCloseOnClickOutside
  class="menu"
  [attr.aria-hidden]="!isOpenInternal()"
  [attr.data-position]="position()"
  [attr.data-mode]="mode()">
  @if (mode() === 'dropdown') {
    @if (title(); as menuTitle) {
      <p class="menu__title">{{ menuTitle }}</p>
    }
  }

  @for (item of internalItems(); track item.key) {
    <!-- TODO remove collapsible - now we provide custom slots instead
      - need refactor theme then will be ok to remove this here -->
    @if (!item.collapsible) {
      <evc-menu-item
        class="item menu__item"
        [attr.data-testid]="item.key"
        [attr.data-key]="item.key"
        [item]="item"
        (click)="toggle(false)" />
    } @else {
      <evc-collapsible-panel
        [content]="item"
        [attr.data-testid]="item.key"
        [attr.data-key]="item.key">
        @for (collapsibleItem of item.collapsible; track collapsibleItem.key) {
          <evc-menu-item
            class="item"
            [attr.data-key]="collapsibleItem.key"
            [attr.data-testid]="`${item.key}-${collapsibleItem.key}`"
            [item]="collapsibleItem"
            (click)="handleCollapsibleItemClick(item, collapsibleItem)"></evc-menu-item>
        }
      </evc-collapsible-panel>
    }
  }

  <ng-content />
</nav>
